module.exports = "pegasus/assets/theme4/facebook-icon-1.png";